import { AnyAction } from 'redux';
import { PensionEnrollmentActionTypes, PensionEnrollmentInfo, PensionEnrollmentState, PensionEnrollmentStep } from './models/pension-enrollment-model';

const InitialState: PensionEnrollmentState = {
    pensionInfo: null,
    pensionInfoLoaded: false,
    currentStep: PensionEnrollmentStep.Landing,
    successfulEnrolledPlan: '',
};

export const pensionEnrollmentReducer = (state = InitialState, action: AnyAction): PensionEnrollmentState => {

    switch (action.type) {
        case PensionEnrollmentActionTypes.SET_PENSION_INFO:
            return {
                ...state,
                pensionInfo: action.payload,
                pensionInfoLoaded: true,
            };
        case PensionEnrollmentActionTypes.SET_PENSION_STEP:
            return {
                ...state,
                currentStep: action.payload,
            };
        case PensionEnrollmentActionTypes.SET_SUCCESS_ENROLLED_PLAN:
            return {
                ...state,
                successfulEnrolledPlan: action.payload,
            };
        case PensionEnrollmentActionTypes.CLEAR_PENSION_INFO:
            return {
                ...InitialState,
            };

        default: return state;
    }
};

export const setPensionEnrollmentInfo = (info: PensionEnrollmentInfo) => {
    return {
        type: PensionEnrollmentActionTypes.SET_PENSION_INFO,
        payload: info,
    };
};

export const setPensionEnrollmentStep = (step: PensionEnrollmentStep) => {
    return {
        type: PensionEnrollmentActionTypes.SET_PENSION_STEP,
        payload: step,
    };
};

export const setSuccessfulEnrolledPlan = (planName: string) => {
    return {
        type: PensionEnrollmentActionTypes.SET_SUCCESS_ENROLLED_PLAN,
        payload: planName,
    };
};

export const clearPensionInfo = () => {
    return {
        type: PensionEnrollmentActionTypes.CLEAR_PENSION_INFO,
    };
};